<template>
  <div id="app">
    <NavBar />
    <main class="main-content">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </main>
    <Footer />
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    Footer
  },
  mounted() {
    // 防御性清理：移除托管平台注入的「AI 生成」水印节点（非本站代码）
    const removeInjectedBadge = () => {
      document.querySelectorAll('body *').forEach((el) => {
        if (
          el.children.length === 0 &&
          el.textContent &&
          el.textContent.replace(/\s+/g, '') === 'AI生成'
        ) {
          const badgeRoot = el.closest('[class*="badge"], [class*="watermark"], [id*="badge"], [id*="watermark"]') || el
          badgeRoot.remove()
        }
      })
    }
    removeInjectedBadge()
    this._badgeObserver = new MutationObserver(removeInjectedBadge)
    this._badgeObserver.observe(document.body, { childList: true, subtree: true })
  },
  beforeUnmount() {
    if (this._badgeObserver) {
      this._badgeObserver.disconnect()
    }
  }
}
</script>

<style>
.main-content {
  min-height: calc(100vh - 200px);
  padding-bottom: 100px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
